import React from 'react';
import './ExtractionListItem.css';

const ExtractionListItem = ({ 
  extraction, 
  isActive, 
  onSelect, 
  formatTimestamp, 
  getStatusLabel, 
  getStatusClass 
}) => {
  const handleClick = () => {
    onSelect(extraction);
  };

  return (
    <div
      className={`extraction-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
    >
      <div className="extraction-preview">
        <div className="extraction-title">
          {extraction.fileName || `Extração ${extraction.id.substring(0, 8)}`}
        </div>
        <div className="extraction-meta">
          <span className="timestamp">{formatTimestamp(extraction.createdAt)}</span>
          <span className={`status ${getStatusClass(extraction.status)}`}>
            {getStatusLabel(extraction.status)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExtractionListItem;
